module.exports = __webpack_public_path__ + "img/Drop Down Menu - Green.d844bee5.png";